import axios from 'axios';
import { objectToQuery } from '@mx/util/object-to-query';
import { toast, modal } from '@mx/vix';
import { bridge } from './bridge';
import { env } from './env';
import { bocLogin } from './utils';

export enum ErrorLevel {
  TOAST = 1,
  MODAL,
  MODAL_EXIT,
  EXIT
}

interface AjaxSettings {
  showToast: boolean;
  showError?: boolean;
}

class CustomError extends Error {
  constructor(message: string, public level: ErrorLevel, public code: number) {
    super(message);
  }
}

// 未登录
const loginCode = ['401', '402', '403', '404', '405', '406', '4001', '100001', '999999', '1000012', '100009'];
function errorHandler(error: CustomError): void {
  // 通用错误码处理
  for (const item of loginCode) {
    if (item === (`${error.code}`)) {
      if (env.isInBoc) {
        bocLogin();
      } else {
        bridge.login();
      }
      sessionStorage.setItem('login', '1');
      return;
    }
  }

  switch (error.level) {
    case ErrorLevel.TOAST:
      if (error.message) {
        toast.show('text', error.message);
      }
      break;
    case ErrorLevel.MODAL_EXIT:
    case ErrorLevel.EXIT:
      modal.show({
        title: '提示',
        content: error.message,
        button: {
          text: '知道了',
          onClick: () => {
            modal.hide();
            bridge.closeWebview();
          }
        }
      });
      break;
    case ErrorLevel.MODAL:
      modal.show({
        title: '提示',
        content: error.message,
        button: {
          text: '知道了',
          onClick: () => {
            modal.hide();
          }
        }
      });
      break;
    default:
      if (error.message) {
        toast.show('text', error.message);
      }
  }
}

export function post(
  url: string,
  data: any,
  settings: AjaxSettings = { showToast: true, showError: true }
) {
  if (settings.showToast) {
    toast.show('loading', '', {
      delay: 0
    });
  }
  return axios
    .post(url, data, {
      timeout: 10000,
      transformRequest: (rawData) => {
        rawData = {
          ...env.commonParams,
          ...rawData
        };
        return objectToQuery(rawData);
      }
    })
    .finally(() => {
      if (settings.showToast) {
        toast.hide();
      }
    })
    .then((res) => {
      const body = res.data; // 响应体
      if (body.error) {
        const error = body.error;
        throw new CustomError(error.message, error.level, error.code);
      }
      return body.data; // 响应体中数据
    })
    .catch((error) => {
      if (error.message.includes('timeout')) {
        error = new CustomError('接口超时，请重试', ErrorLevel.TOAST, 0);
      }
      if (!error.level) {
        error = new CustomError('接口返回异常，请重试', ErrorLevel.TOAST, 0);
      }
      if (settings.showError) {
        errorHandler(error);
      }
      throw error;
    });
}

export function get(
  url: string,
  data: any,
  settings: AjaxSettings = { showToast: true, showError: true }
) {
  if (settings.showToast) {
    toast.show('loading', '', {
      delay: 0
    });
  }
  return axios
    .get(url, {
      params: data,
      timeout: 10000,
      transformRequest: (rawData) => {
        rawData = {
          ...env.commonParams,
          ...rawData
        };
        return objectToQuery(rawData);
      }
    })
    .finally(() => {
      if (settings.showToast) {
        toast.hide();
      }
    })
    .then((res) => {
      const body = res.data; // 响应体
      if (body.error) {
        const error = body.error;
        throw new CustomError(error.message, error.level, error.code);
      }
      return body.data; // 响应体中数据
    })
    .catch((error) => {
      if (error.message.includes('timeout')) {
        error = new CustomError('接口超时，请重试', ErrorLevel.TOAST, 0);
      }
      if (!error.level) {
        error = new CustomError('接口返回异常，请重试', ErrorLevel.TOAST, 0);
      }
      if (settings.showError) {
        errorHandler(error);
      }
      throw error;
    });
}
